import { Box, Button } from "@mui/material";
import { useState } from "react";
import useAPI from "../../api/hooks/useAPI";
import { useCheckUserPermission } from "../../api/hooks/useCheckUserPermission";
import useColors from "../../api/hooks/useColors";
import { ReactComponent as AddCircleIcon } from "../../icons/icon_files/add_circle_24.svg";
import { ReactComponent as RemoveCircleIcon } from "../../icons/icon_files/remove_circle_24.svg";
import SvgToIcon from "../../icons/SvgToIcon";
import { PLATFORM_USER_ACTIONS } from "../../utils/constants";
import CustomToolTipWithPermission from "../CustomToolTipWithPermission";
import ExclusionMenu from "../menus/ExclusionMenu";

const ExcludeOrIncludeButton = ({
  is_excluded,
  handleExclusion,
  toolTipText = { exclude: "Exclude", include: "Include" },
  disabledTooltipText = {
    exclude: "Select entities to exclude from risk",
    include: "Select entities to include in risk",
  },
  disabled = false,
  isExcludingAll = false,
  isExcludingMisconfiguration = false,
  sx = {},
}) => {
  const { permitted: hasPermission } = useCheckUserPermission(
    PLATFORM_USER_ACTIONS.EXCLUDE_OR_INCLUDE_ENTITY_FROM_RISK
  );
  const colors = useColors();
  const { trackEvent } = useAPI();
  const [anchorEl, setAnchorEl] = useState(null);

  let tooltipTitle;
  if (disabled) {
    if (is_excluded) {
      tooltipTitle = disabledTooltipText.include;
    } else {
      tooltipTitle = disabledTooltipText.exclude;
    }
  } else {
    if (is_excluded) {
      tooltipTitle = toolTipText.include;
    } else {
      tooltipTitle = toolTipText.exclude;
    }
  }

  const onClick = (event) => {
    if (disabled || !hasPermission) {
      return;
    }

    trackEvent("User pressed on Exclude or Include button");

    if (is_excluded) {
      handleExclusion();
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  return (
    <>
      <CustomToolTipWithPermission
        title={tooltipTitle}
        permission={hasPermission}
        placement="top"
      >
        <Box>
          <Button
            sx={{
              color: colors.text_primary,
              width: "32px",
              height: "32px",
              border: "1px solid " + colors.enabled_stroke,
              backgroundColor: colors.common_white,
              borderRadius: "8px",
              cursor: "pointer",
              minWidth: "auto",
            }}
            onClick={onClick}
            disabled={disabled || !hasPermission}
          >
            {is_excluded ? (
              <SvgToIcon
                IconLogo={AddCircleIcon}
                width="18px"
                style={{
                  color:
                    disabled || !hasPermission
                      ? colors.action_disabled
                      : colors.icon_action_active,
                }}
              />
            ) : (
              <SvgToIcon
                IconLogo={RemoveCircleIcon}
                width="18px"
                style={{
                  color:
                    disabled || !hasPermission
                      ? colors.action_disabled
                      : colors.icon_action_active,
                }}
              />
            )}
          </Button>
        </Box>
      </CustomToolTipWithPermission>

      <ExclusionMenu
        anchorEl={anchorEl}
        handleClose={() => setAnchorEl(null)}
        handleExclusion={handleExclusion}
        isExcludingAll={isExcludingAll}
        isExcludingMisconfiguration={isExcludingMisconfiguration}
      />
    </>
  );
};
export default ExcludeOrIncludeButton;
